/**
 * userAudit.service.ts
 *
 * GET /admin/user-audit (UserAuditController). Times arrive already in the
 * Account's timezone; `meta.timezoneShort` names it. A refusal is a 422 with
 * `error.code = USER_AUDIT_DENIED` and a plain message, never a 401/403, which
 * the API client would treat as a lost sign-in.
 */
import { apiClient } from '@/services/apiClient';

export type UserAuditActivity =
  | 'Signed in'
  | 'Signed out'
  | 'Signed out for inactivity'
  | 'Opened'
  | 'Created'
  | 'Changed'
  | 'Deleted'
  | 'Exported';

export interface UserAuditRow {
  id: number;
  /** "YYYY-MM-DD HH:MM:SS", Account local. */
  occurredAt: string;
  timeZone: string;
  staffUserId: number;
  staffName: string;
  corporateAdminName: string | null;
  kind: string;
  activity: UserAuditActivity | string;
  description: string;
}

export interface UserAuditMeta {
  total: number;
  page: number;
  perPage: number;
  totalPages: number;
  /** The Account's first recorded activity, Account local; null when there is none. */
  recordingStartedAt: string | null;
  timezone: string;
  timezoneShort: string;
}

export interface UserAuditResponse {
  data: UserAuditRow[];
  meta: UserAuditMeta;
}

export async function listUserAudit(params: Record<string, string | number>): Promise<UserAuditResponse> {
  const r = await apiClient.get<{ data: UserAuditRow[]; meta: UserAuditMeta }>('/admin/user-audit', { params });
  return { data: r.data.data ?? [], meta: r.data.meta };
}
